import { render, staticRenderFns } from "./PlanoBimestralIndividualAEE.vue?vue&type=template&id=2004a50f"
import script from "./PlanoBimestralIndividualAEE.vue?vue&type=script&lang=js"
export * from "./PlanoBimestralIndividualAEE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports